/* Copyright (c) 2018 Verge Technologies
 * @file header.js
 * @author Brenton Watt
 * @description Footer component for Seperations
 */

import React, { Component } from 'react';
import validator from 'validator';
import { Mutation } from 'react-apollo';
import { Link } from 'react-router-dom';

import { SUBSCRIBE_EMAIL } from '../../graphql';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // Handles the submit action of the subscribe to newsletter form
  handleSubmit(e, mutation) {
    e.preventDefault();
    // Ensure the current value in state complies with email pattern
    if (validator.isEmail(this.state.email)) {
      mutation();
      this.setState({
        ...this.state,
        email: '',
      });
    }
  }

  scrollTo() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <footer>
        <div className="footer-top">
          <h5 style={{ color: 'white' }}>Require further assistance?</h5>
          <p>
            <svg viewBox="0 0 29.104 28.414">
              <path
                fill="#fff"
                d="M21.794,11.1a1.388,1.388,0,0,0,1.921,0L29.1,5.715A6.015,6.015,0,0,0,20.7.5a28.853,28.853,0,0,0-3.638,1.646A37.529,37.529,0,0,0,8,8.763a33.146,33.146,0,0,0-4.218,5.072A34.371,34.371,0,0,0,.322,20.45h0a6.022,6.022,0,0,0,1.442,6.22,5.821,5.821,0,0,0,4.15,1.749L11.3,23.034a1.388,1.388,0,0,0,0-1.921l-4.732-4.7H6.532c.1-.172.206-.309.309-.481a30,30,0,0,1,3.773-4.561,32.323,32.323,0,0,1,6.447-5.008Z"
                transform="translate(0.005 -0.005)"
              />
            </svg>
            <a href="tel:+27119191000">+27 11 919 1000</a>
          </p>
          <Link to="/contactus" className="button button-green" onClick={() => this.scrollTo()}>
            Contact us
          </Link>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="col-menu">
              <h5>Contact details</h5>
              <hr />
              <ul>
                <li>
                  Johannesburg:
                  <br />
                  <a href="tel:+27119191000">+27 11 919 1000</a>
                </li>
                <li>
                  Cape Town:
                  <br />
                  <a href="tel:+27215579480">+27 21 557 9480</a>
                </li>
                <li>
                  Fax:
                  <br />
                  +27 86 585 4676
                </li>
                <li>
                  Email:
                  <br />
                  <a href="mailto:info@separations.co.za">info@separations.co.za</a>
                </li>
              </ul>
            </div>
            <div className="col-menu">
              <h5>Menu</h5>
              <hr />
              <ul>
                <li>
                  <Link to="/services_support" onClick={() => this.scrollTo()}>Services & Support</Link>
                </li>
                <li>
                  <Link to="/products" onClick={() => this.scrollTo()}>Products</Link>
                </li>
                <li>
                  <Link to="/specials" onClick={() => this.scrollTo()}>Special Offers</Link>
                </li>
                <li>
                  <Link to="/articles" onClick={() => this.scrollTo()}>Articles</Link>
                </li>
                <li>
                  <Link to="/about" onClick={() => this.scrollTo()}>About</Link>
                </li>
                <li>
                  <Link to="/contactus" onClick={() => this.scrollTo()}>Contact</Link>
                </li>
              </ul>
            </div>
            <div className="col-menu">
              <h5>Browse</h5>
              <hr />
              <ul>
                <li>
                  <Link to="/specials">Special Offers</Link>
                </li>
                <li>
                  <Link to="/products">Products</Link>
                </li>
              </ul>
            </div>
            <div className="col-menu">
              <h5>Social media</h5>
              <hr />
              <ul>
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="http://www.facebook.com/separations"
                  >
                    Facebook
                  </a>
                </li>

                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.youtube.com/channel/UC2fmIGkTOlZIAG1pes3zdvg"
                  >
                    YouTube
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.linkedin.com/company/separations"
                  >
                    LinkedIn
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-menu col-wide">
              <h5>Subscribe</h5>
              <hr />
              <Mutation
                mutation={SUBSCRIBE_EMAIL}
                variables={{ email: this.state.email }}
                onCompleted={(data) => {
                  const message = JSON.parse(data.subscribeEmail);
                  if (message.code === 200) {
                    alert('You have succesfully been subscribed');
                  }
                }}
              >
                {(postMutation) => {
                  return (
                    <div className="form">
                      <input
                        type="email"
                        autoComplete="off"
                        name="email"
                        placeholder="Email..."
                        value={this.state.email}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            email: e.target.value,
                          });
                        }}
                      />
                      <a
                        href={null}
                        className="button button-grey"
                        onClick={e => this.handleSubmit(e, postMutation)}
                      >
                        Subscribe
                      </a>
                    </div>
                  );
                }}
              </Mutation>
            </div>
          </div>
        </div>
        <div className="footer-bar">
          <div className="container">
            <ul>
              <li>
                <Link to="/terms" onClick={() => this.scrollTo()}>Terms and conditions</Link>
              </li>
              <li>
                <Link to="/privacy" onClick={() => this.scrollTo()}>Privacy Policy</Link>
              </li>                 
              <li>
                <a href={null}>Copyright 2018 © Separations</a>
              </li>
              <li>
                <a href="https://verge.co.za" target="_blank" rel="noopener noreferrer">Developed by Verge Technologies</a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Footer/footer.js